// Auto-generated cornerstone translation for ro.
// Source: cornerstones/nl.js, translated via Claude on 2026-05-28T16:05:16.257157+00:00.

export const CORNERSTONES = {
  beste: {
    seo: {
      title: "Aplicație management cai: cea mai bună alegere pentru 2026 | EquiSight",
      description: "Compară aplicații de management pentru cai, destinare proprietarilor, grajdurilor și crescătoriilor. Descoperă de ce EquiSight este aplicația completă pentru calul tău.",
      keywords: [
        "aplicație management cai",
        "aplicație management grajd",
        "jurnal digital cai",
        "aplicație pentru gestionarea mai multor cai",
        "aplicație gestație iapă",
        "aplicație crescătorie cai",
        "cea mai bună aplicație management cai",
      ],
    },
    hero: {
      eyebrow: "Ghid de alegere · software management cai",
      breadcrumbLabel: "Aplicație management cai",
      title: "Aplicație management cai: ghidul complet de alegere pentru proprietari, grajduri și crescătorii.",
      intro: "Nu doar o listă de funcții — o comparație corectă, un ghid de alegere și o privire asupra a ceea ce o aplicație de management pentru cai trebuie să poată face cu adevărat în 2026. Pentru un singur cal, pentru un întreg grajd sau pentru crescătoria ta.",
      pills: [
        {
          icon: "Users",
          label: "Pentru proprietari",
        },
        {
          icon: "Building2",
          label: "Pentru grajduri",
        },
        {
          icon: "Baby",
          label: "Pentru crescătorii",
        },
        {
          icon: "Share2",
          label: "Pentru echipe",
        },
      ],
      ctas: [
        {
          label: "Începe gratuit cu 1 cal",
          href: "#start",
          primary: true,
        },
        {
          label: "Spre tabelul comparativ",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "De ce o aplicație de management pentru cai devine tot mai importantă.",
      lead: "Gestionarea cailor este în practică fragmentată: WhatsApp, agendă, Excel, fotografii pe telefon, un pașaport pe hârtie, facturi separate și înțelegeri verbale. Incomod chiar și pentru un singur cal. Când ai mai mulți cai, o crescătorie sau îngrijire partajată, apar goluri, programări ratate și neînțelegeri.",
      items: [
        "Unde era acea dată de vaccinare?",
        "Cine a plătit potcovarul?",
        "Care iapă trebuie verificată astăzi?",
        "A citit antrenorul instrucțiunile de săptămâna trecută?",
        "Am salvat cu adevărat acel document foto?",
        "Mai este valabilă schema de hrănire afișată în grajd?",
      ],
    },
    what: {
      title: "Ce este o aplicație de management pentru cai?",
      lead: "O aplicație de management pentru cai este în esență un dosar digital per cal. Fără notițe împrăștiate, ci un singur loc pentru sănătate, antrenament, hrănire, documente, planificare, remindeuri, costuri, fotografii, videoclipuri și acces partajat. Toți cei din jurul calului văd aceleași informații actuale.",
      targetGroupsTitle: "Pentru cine este destinată o aplicație de management pentru cai?",
      targetGroups: [
        {
          icon: "Heart",
          title: "Proprietar individual",
          body: "Un cal, un dosar — sănătate, planificare și istoric în buzunarul tău.",
        },
        {
          icon: "Users",
          title: "Proprietar cu mai mulți cai",
          body: "Profile separate, planificare separată, listă de sarcini partajată pentru întreaga echipă.",
        },
        {
          icon: "Building2",
          title: "Pensiune & manej",
          body: "Acces proprietar, instrucțiuni de îngrijire, agendă și sarcini partajate.",
        },
        {
          icon: "Baby",
          title: "Crescătorie",
          body: "Ciclul iepei, gestație, date armăsar, arbore genealogic și dezvoltarea mânzului.",
        },
        {
          icon: "Target",
          title: "Antrenori",
          body: "Vizualizare per cal, înregistrare sesiuni, stabilire obiective, analiză videoclipuri.",
        },
        {
          icon: "ClipboardList",
          title: "Profesioniști",
          body: "Potcovar, dentist, fizioterapeut sau veterinar — lucrează din același dosar.",
        },
      ],
    },
    criteria: {
      title: "Ce criterii trebuie să îndeplinească o aplicație bună de management pentru cai?",
      lead: "O aplicație nu este doar frumoasă — trebuie să funcționeze practic zilnic. Cinci componente care nu pot lipsi din alegerea pentru 2026.",
      items: [
        {
          icon: "FileText",
          title: "Dosar per cal",
          body: "Date, vârstă, rasă, informații pașaport, proprietar, grajd, fotografii și documente — toate legate de un singur profil de cal.",
        },
        {
          icon: "Heart",
          title: "Sănătate și îngrijire",
          body: "Vaccinuri, deparazitare, potcovar, dentist, veterinar, tratamente, medicație și remindeuri automate înainte de data expirării.",
        },
        {
          icon: "Activity",
          title: "Antrenament și progres",
          body: "Înregistrare antrenamente, notițe, videoclipuri, rezultate concursuri, obiective și progres pe disciplină sau per cal.",
        },
        {
          icon: "Apple",
          title: "Hrănire și management",
          body: "Scheme de hrănire, suplimente, furaje grosiere, greutate, condiție corporală și rutina zilnică pe care grajdul trebuie să o cunoască.",
        },
        {
          icon: "Share2",
          title: "Partajare cu alții",
          body: "Acces pentru proprietar, îngrijitor, antrenor, proprietar de grajd sau profesionist — cu gestionarea drepturilor adaptată rolului fiecăruia.",
        },
        {
          icon: "Calendar",
          title: "Planificare și remindeuri",
          body: "O agendă partajată cu sarcini, remindeuri automate și confirmare astfel încât nimic să nu se piardă.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs alte aplicații de management pentru cai.",
      lead: "Pe piața din România și Europa există mai multe aplicații dedicate. Au fiecare punctele lor forte. Prezentăm cele mai solicitate funcții alături, corect și pe baza informațiilor disponibile public.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "LogMyHorse",
        "EquineM",
        "Happie Horse",
      ],
      rows: [
        {
          label: "Începe gratuit",
          values: [
            true,
            true,
            true,
            false,
            true,
          ],
        },
        {
          label: "Mai mulți cai",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dosar de sănătate",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Antrenament și progres",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Hrănire și suplimente",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Planificare și remindeuri",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Documente per cal",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Partajare echipă și drepturi",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Modul crescătorie (complet)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Ciclul iepei",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Planificare gestație + ecografii",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Dezvoltare mânz",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Integrare profesioniști",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Informații EquiCoach",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Potrivit pentru proprietari",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Potrivit pentru crescătorii",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Potrivit pentru grajd/manej",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Comparație pe baza funcțiilor disponibile public în ianuarie 2026. Concurenții sunt de asemenea instrumente bune; EquiSight este construit pentru a combina toate modulele într-o singură aplicație.",
    },
    why: {
      title: "De ce EquiSight este diferit.",
      lead: "Un jurnal înregistrează. EquiSight combină managementul cailor, antrenamentul, hrănirea, sănătatea, concursurile, profesioniștii și crescătoria într-o singură aplicație modernă — și merge un pas mai departe cu informații valoroase.",
      points: [
        {
          icon: "Heart",
          title: "O singură aplicație pentru întreaga viață a calului",
          body: "De la mânz la cal de sport, iapă de reproducție sau cal la pensie. Dosarul crește odată cu calul tău — nimic nu se pierde pe parcurs.",
        },
        {
          icon: "Sparkles",
          title: "Nu doar date, ci și tipare",
          body: "EquiCoach combină dezvoltarea, afecțiunile recurente, antrenamentul și hrănirea — astfel încât să observi semnalele din timp, nu notificări izolate.",
        },
        {
          icon: "Share2",
          title: "Construit pentru colaborare",
          body: "Proprietar, proprietar de grajd, antrenor, potcovar și alți profesioniști lucrează din același dosar — cu drepturile corespunzătoare rolului lor.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Nișă · crescătorie",
      title: "Management cai pentru crescătorii.",
      lead: "Mulți concurenți menționează crescătoria într-o singură linie. EquiSight a construit un modul complet de crescătorie — deoarece crescătorul este rareori utilizatorul final al unei aplicații generale, dar are nevoie de planificare mai mult decât oricine altcineva.",
      items: [
        "Urmărirea zilnică a ciclului iepei",
        "Data inseminării + date armăsar",
        "Control gestație cu ecografii",
        "Data estimată a fătării + avertizări",
        "Dezvoltarea mânzului pe luni",
        "Arbore genealogic și descendență",
        "Notițe per iapă",
        "Prezentare generală a tuturor iepelor gestante",
      ],
      ctaLabel: "Vezi modulul de crescătorie",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Nișă · grajd & manej",
      title: "Management cai pentru mai mulți cai și pensiuni ecvestre.",
      lead: "Când ai mai mulți cai, contează mai puțin datele și mai mult comunicarea. Fiecare proprietar are propriile preferințe, rutine, scheme de hrănire și aspecte medicale de urmărit. Fiecare angajat trebuie să le acceseze fără să caute.",
      cards: [
        {
          t: "Cai per proprietar",
          d: "Fiecare proprietar vede doar calul (caii) săi.",
        },
        {
          t: "Instrucțiuni de îngrijire",
          d: "Vizibile per cal pentru personalul grajdului.",
        },
        {
          t: "Agendă partajată",
          d: "Potcovar, veterinar și concursuri într-o singură vizualizare.",
        },
        {
          t: "Listă de sarcini",
          d: "Atribuire angajaților, cu confirmare.",
        },
        {
          t: "Acces proprietar",
          d: "Clienții își văd calul în propria aplicație.",
        },
        {
          t: "Contacte de urgență",
          d: "Mereu accesibile în situații de stres la grajd.",
        },
      ],
      ctaLabel: "Vezi modulul pentru manej",
      ctaHref: "/manege-module",
    },
    beforeAfter: {
      title: "De la WhatsApp, Excel și tablă albă la EquiSight.",
      lead: "Concret: iată cum se schimbă gestionarea zilnică a cailor tăi.",
      rows: [
        {
          before: "Grupuri de WhatsApp",
          after: "Notițe structurate per cal",
        },
        {
          before: "Foi Excel",
          after: "Dosar live cu istoric",
        },
        {
          before: "Tablă albă în grajd",
          after: "Planificare partajată pe telefon",
        },
        {
          before: "Fotografii împrăștiate pe cameră",
          after: "Media legată de calul tău",
        },
        {
          before: "Înțelegeri verbale",
          after: "Sarcini și remindeuri cu confirmare",
        },
        {
          before: "Pașaport pe hârtie pierdut",
          after: "Documente mereu la îndemână",
        },
      ],
    },
    helper: {
      title: "Ce aplicație de management pentru cai ți se potrivește?",
      lead: "Răspunde la aceste 5 întrebări și vei primi o recomandare corectă — chiar dacă aceasta nu este întotdeauna EquiSight.",
      questions: [
        {
          id: "horses",
          q: "Ai un cal sau mai mulți cai?",
          options: [
            {
              label: "Un singur cal",
              score: 1,
            },
            {
              label: "2–5 cai",
              score: 2,
            },
            {
              label: "Mai mult de 5 cai",
              score: 3,
            },
          ],
        },
        {
          id: "clients",
          q: "Gestionezi caii clienților sau terților?",
          options: [
            {
              label: "Nu, doar caii mei proprii",
              score: 0,
            },
            {
              label: "Uneori — pentru familie sau cunoscuți",
              score: 1,
            },
            {
              label: "Da, profesional (grajd / manej)",
              score: 3,
            },
          ],
        },
        {
          id: "breeding",
          q: "Vrei să urmărești crescătoria și gestația?",
          options: [
            {
              label: "Nu este relevant",
              score: 0,
            },
            {
              label: "Uneori — reproducție ocazională",
              score: 1,
            },
            {
              label: "Da, sunt (sau voi deveni) crescător",
              score: 3,
            },
          ],
        },
        {
          id: "collab",
          q: "Colaborezi cu un antrenor, îngrijitor sau profesionist?",
          options: [
            {
              label: "Nu, fac totul singur",
              score: 0,
            },
            {
              label: "Da, cu o persoană",
              score: 1,
            },
            {
              label: "Da, cu mai multe persoane",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Vrei doar să înregistrezi sau vrei și informații valoroase?",
          options: [
            {
              label: "Doar înregistrare",
              score: 1,
            },
            {
              label: "Înregistrare + planificare",
              score: 2,
            },
            {
              label: "Înregistrare + planificare + informații valoroase",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Un jurnal simplu este suficient — și crește odată cu tine.",
          body: "Pentru un singur cal fără îngrijire partajată, orice aplicație de management pentru cai este potrivită. EquiSight începe gratuit cu 1 cal, deci nu există niciun risc. Dacă mai târziu vrei să adaugi mai mulți cai, un antrenor sau o crescătorie, totul este deja inclus.",
          cta: "Începe gratuit cu 1 cal",
        },
        mid: {
          title: "EquiSight se potrivește bine situației tale.",
          body: "Ai mai multe nevoi (mai mulți cai, colaborare sau informații valoroase). Majoritatea concurenților acoperă 1-2 module; EquiSight le combină într-o singură aplicație, fără a conecta instrumente separate.",
          cta: "Vezi ce poate face EquiSight",
        },
        high: {
          title: "EquiSight este alegerea cea mai logică.",
          body: "Situația ta combină mai mulți cai, colaborare, crescătorie și/sau informații valoroase. Exact aici face EquiSight diferența — fără instrumente fragmentate, ci un singur dosar pentru tot și toți cei din jurul calului.",
          cta: "Începe gratuit cu EquiSight",
        },
      },
    },
    faqTitle: "Întrebări frecvente despre aplicațiile de management pentru cai",
    faq: [
      {
        q: "Care este cea mai bună aplicație de management pentru cai?",
        a: "Cea mai bună aplicație de management pentru cai depinde de situația ta. Pentru un simplu jurnal, mai multe aplicații sunt potrivite. Dacă vrei să combini sănătatea, antrenamentul, hrănirea, documentele, crescătoria, planificarea și colaborarea, atunci EquiSight este construit ca soluție completă în care totul se reunește într-un singur dosar.",
      },
      {
        q: "Pot gestiona mai mulți cai într-o singură aplicație?",
        a: "Da. O aplicație bună de management pentru cai trebuie să suporte mai mulți cai, inclusiv proprietari, îngrijitori, rutine, documente, programări și remindeuri per cal. EquiSight a fost proiectat astfel încă din prima linie de cod — caii sunt dosare individuale, nu rânduri într-o listă.",
      },
      {
        q: "Este EquiSight potrivit și pentru crescătorii?",
        a: "Da. EquiSight poate fi configurat cu funcții de crescătorie precum ciclul iepei, data inseminării, controlul gestației, datele armăsarului, arborele genealogic, data estimată a fătării și dezvoltarea mânzului. Acesta este exact domeniul în care majoritatea aplicațiilor concurente nu oferă sau oferă foarte puțin.",
      },
      {
        q: "Pot partaja datele cu antrenorul sau potcovarul meu?",
        a: "Da. Scopul EquiSight este că informațiile relevante pot fi partajate în siguranță cu persoanele din jurul calului — antrenor, potcovar, dentist, veterinar, fizioterapeut, îngrijitor sau proprietar. Fiecare persoană primește doar drepturile necesare rolului său.",
      },
      {
        q: "De ce să nu folosești pur și simplu WhatsApp sau Excel?",
        a: "WhatsApp și Excel funcționează atâta timp cât lucrurile rămân simple. De îndată ce ai mai mulți cai, programări, documente, tratamente, proprietari sau date de crescătorie, devine predispus la erori: informațiile se dispersează, recuperarea datelor consumă timp, iar înțelegerile verbale dispar. O aplicație de management pentru cai reunește totul per cal, cu remindeuri automate.",
      },
      {
        q: "Cât costă EquiSight?",
        a: "Poți începe gratuit cu 1 cal. Dacă vrei să gestionezi mai mulți cai, să activezi crescătoria sau să oferi acces profesioniștilor, există planuri Premium accesibile. Consultați opțiunile actuale pe pagina de prețuri.",
      },
    ],
  },
  fokkerij: {
    seo: {
      title: "Software reproducție cai: comparație completă 2026",
      description: "Comparați software reproducție pentru cai: ciclu estrual, gestație, alegerea soiului și mânzii. Descoperiți de ce EquiSight este aplicația completă de reproducție.",
      keywords: [
        "software reproducție cai",
        "app ciclu estrual",
        "app gestație iapă",
        "app înregistrare mânz",
        "app registru genealogic",
        "planificare montare cai",
        "app alegere soi",
      ],
    },
    hero: {
      eyebrow: "Ajutor alegere · software reproducție",
      breadcrumbLabel: "Software reproducție",
      title: "Software reproducție pentru cai: comparația completă pentru 2026.",
      intro: "O iapă reproducătoare merită mai mult decât o aplicație generică de gestionare a cailor. Comparați funcțiile de reproducție ale celor mai cunoscute instrumente, descoperiți pe ce trebuie cu adevărat să vă concentrați și alegeți în cunoștință de cauză software-ul care se potrivește grajdului dvs. — mare sau mic.",
      pills: [
        {
          icon: "Baby",
          label: "Ciclu estrual",
        },
        {
          icon: "Heart",
          label: "Control gestație",
        },
        {
          icon: "Sparkles",
          label: "Dezvoltare mânz",
        },
        {
          icon: "FileText",
          label: "Registru genealogic",
        },
      ],
      ctas: [
        {
          label: "Începeți gratuit cu modulul reproducție",
          href: "#start",
          primary: true,
        },
        {
          label: "Spre tabel comparație",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "De ce o aplicație obișnuită de gestionare a cailor nu este suficientă pentru reproducție.",
      lead: "Majoritatea aplicațiilor sportive cu cai sunt proiectate pentru un singur cal de sport sau recreație. Un grajd de reproducție are un ritm complet diferit: estrualitate, inseminare, control gestație, ecografii, calendar mânz, genealogie și vânzare. Un Excel se dezordinează după 2 sezoane — și cu mai multe iaape pierzi controlul.",
      items: [
        "Care a fost ultima estrualitate a lui Bonita?",
        "Care soi este planificat pentru montare sezonul viitor?",
        "Ecografia din a 21-a zi este deja programată?",
        "Care dintre mânzii din 2024 sunt deja vânduți?",
        "Unde se află diagrama genealogică până la bunicul din partea mamei?",
        "Unde sunt mostrrele de ADN și documentele de pașaport?",
      ],
    },
    what: {
      title: "Ce este software-ul de reproducție pentru cai?",
      lead: "Software-ul de reproducție este un dosar specializat per iapă și soi, combinat cu un calendar de an de reproducție, planificare gestație, înregistrare mânz și afișare genealogică. Nu un jurnal general de cai, ci un instrument care înțelege ciclul de reproducție: de la prima estrualitate până la dezlăptare.",
      targetGroupsTitle: "Pentru ce tip de reproducător este destinat software-ul de reproducție?",
      targetGroups: [
        {
          icon: "Baby",
          title: "Reproducător hobby (1-3 iaape)",
          body: "Una sau două montări pe an — control fără acrobații Excel.",
        },
        {
          icon: "Building2",
          title: "Grajd mic (4-10 iaape)",
          body: "Un plan de reproducție cu ciclu, inseminare, controale gestație și dosar mânz.",
        },
        {
          icon: "Users",
          title: "Grajd profesional (10+)",
          body: "Mai mulți angajați, alegere soi per iapă, vânzare și marketing.",
        },
        {
          icon: "Target",
          title: "Producător soi",
          body: "Istoric comenzi, statistici spermă și program per soi.",
        },
        {
          icon: "Heart",
          title: "Transfer embrionar",
          body: "Iapă donator + iapă destinatară ca dosar conectat, calendar TE.",
        },
        {
          icon: "ClipboardList",
          title: "Înregistrare registru genealogic",
          body: "Mostre ADN, documente pașaport și date genealogice.",
        },
      ],
    },
    criteria: {
      title: "La ce trebuie să îndeplinească bun software-ul de reproducție?",
      lead: "Nu fiecare \"funcție de reproducție\" dintr-o aplicație de cai este aceeași. Cinci domenii esențiale unde reproducătorii pierd mult timp — și unde software-ul face cu adevărat diferență.",
      items: [
        {
          icon: "Calendar",
          title: "Ciclu estrual și estrualitate",
          body: "Log zilnic, ovulație predictivă, derulare per ciclu și remindere automate.",
        },
        {
          icon: "Heart",
          title: "Inseminare și control gestație",
          body: "Dată montare și inseminare, date soi, ecografie 14-zile, ecografie 21-zile, ecografie 60-zile și determinare sex.",
        },
        {
          icon: "Baby",
          title: "Dezvoltare mânz",
          body: "Date naștere, grafic greutate, program deparazitare, moment dezlăptare, înregistrare pașaport.",
        },
        {
          icon: "FileText",
          title: "Genealogie și documente",
          body: "Afișare genealogică până la 4-5 generații, ADN, numere pașaport și stare registru genealogic.",
        },
        {
          icon: "Target",
          title: "Alegere soi și potrivire",
          body: "Filtru pe disciplină, linii, date soi și succes istoric — nu doar ce promovează un producător de soi.",
        },
        {
          icon: "Share2",
          title: "Colaborare medic veterinar/inseminator",
          body: "Ecografii, mostre și stări împărtășite direct cu clinica care lucrează la iaapele dvs.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs alt software de reproducție.",
      lead: "SERP-ul olandez pentru software reproducție arată adesea aplicații generice de cai care menționează reproducția într-o singură propoziție. Comparăm cinstit care instrumente au cu adevărat un flux de reproducție complet.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "HorseManager",
        "EquineGenie",
        "Foal-Excel",
      ],
      rows: [
        {
          label: "Început gratuit",
          values: [
            true,
            true,
            false,
            false,
            true,
          ],
        },
        {
          label: "Log ciclu estrual",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dată inseminare + soi",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Ecografii și control gestație",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Dată așteptată mânz",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dosar mânz (greutate/creștere)",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Genealogie până la 4-5 generații",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "ADN și înregistrare pașaport",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Alegere soi / potrivire",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "TE / transfer embrionar",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Privire generală multi-iapă",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Mobil (iOS/Android)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Partajare cu medic veterinar",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integrat cu dosar general",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Vânzare și marketing mânz",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Comparație pe baza caracteristicilor disponibile public în ianuarie 2026. EquineGenie este puternic în reproducție, dar mai slab în mobil + gestionare generală de cai. EquiSight combină ambele.",
    },
    why: {
      title: "De ce EquiSight servește reproducătorii diferit.",
      lead: "Mulți reproducători lucrează cu software-ul de reproducție separat și o aplicație de gestionare a cailor separată. EquiSight combină ambele — fără să comutați între aplicații sau să introduceți date de două ori.",
      points: [
        {
          icon: "Heart",
          title: "Iapa reproducătoare rămâne și cal obișnuit",
          body: "Iapa reproducătoare are un an de reproducție și un dosar de cal obișnuit — sănătate, vaccinări, ferăstru. O aplicație, toate modulele.",
        },
        {
          icon: "Sparkles",
          title: "Predictiv în loc de reactiv",
          body: "Predicție ciclu, remindere reper gestație și calendar mânz — automat pe baza datelor dvs.",
        },
        {
          icon: "Share2",
          title: "Toți în jurul reproducției",
          body: "Inseminator, producător soi, medic veterinar, cumpărător, registru genealogic — toți au acces cu drepturi corespunzătoare.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Per disciplină · ciclu până la dezlăptare",
      title: "Ce conține un dosar de reproducție în EquiSight.",
      lead: "Per iapă obțineți un dosar complet de reproducție, conectat la dosarul ei regulat de cal.",
      items: [
        "Log zilnic de ciclu cu predicție",
        "Inseminare/montare + date soi",
        "Calendar ecografie (14/21/60 zile + sex)",
        "Repere gestație cu remindere automate",
        "Dată mânz așteptată și pregătire",
        "Dosar mânz de la naștere",
        "Genealogie până la bunici cu navigare clic",
        "Mostră ADN, pașaport, stare registru genealogic",
        "Pipeline vânzare cu interesați",
        "Istoric alegere soi per iapă",
      ],
      ctaLabel: "Vedeți modulul reproducție",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Pentru tot grajdul",
      title: "Privire generală pentru mai multe iaape și soii.",
      lead: "Când reproduci mai mult de 2-3 iaape, controlul asupra tuturor ciclurilor și gestațiilor devine crucial.",
      cards: [
        {
          t: "Tablou de bord ciclu",
          d: "Toate iaapele una lângă alta, cu stadiu ciclu și următoarea acțiune.",
        },
        {
          t: "Pipeline gestație",
          d: "Care iaape sunt unde în reperele gestației?",
        },
        {
          t: "Calendar mânz",
          d: "Nașteri așteptate pe lună, cu logistică reglată în consecință.",
        },
        {
          t: "Portofoliu soi",
          d: "Soii proprii sau inseminatori fixi cu istoric comenzi.",
        },
        {
          t: "Grafic genealogic",
          d: "Analiză strămoși peste mai multe generații și linii.",
        },
        {
          t: "Tablou de bord vânzare",
          d: "Care mânzi sunt vânduți, rezervați sau încă disponibili.",
        },
      ],
    },
    beforeAfter: {
      title: "De la Excel + agendă la EquiSight reproducție.",
      lead: "Concret: așa se schimbă sezonul dvs. de reproducție.",
      rows: [
        {
          before: "Ciclu în notă separată",
          after: "Log zilnic cu predicție",
        },
        {
          before: "Ecografii prin WhatsApp la inseminator",
          after: "Dosar partajat cu fotografii",
        },
        {
          before: "Dată gestație în agendă",
          after: "Remindere reper automate",
        },
        {
          before: "Pașaport mânz în sertar",
          after: "Document conectat la profil mânz",
        },
        {
          before: "Genealogie pe hârtie",
          after: "Genealogie clicabilă până la 4-5 generații",
        },
        {
          before: "Anunț vânzare pe Marktplaats",
          after: "Pipeline vânzare cu listă interesați",
        },
      ],
    },
    helper: {
      title: "Care software de reproducție se potrivește pentru tine?",
      lead: "5 întrebări pentru a vedea dacă ai nevoie de o aplicație completă de reproducție sau o unealtă hobby este suficientă.",
      questions: [
        {
          id: "mares",
          q: "Câte iaape reproducătoare gestionezi?",
          options: [
            {
              label: "1 iapă",
              score: 1,
            },
            {
              label: "2-5 iaape",
              score: 2,
            },
            {
              label: "Mai mult de 5 iaape",
              score: 3,
            },
          ],
        },
        {
          id: "frequency",
          q: "Cât de des reproduci pe an?",
          options: [
            {
              label: "Ocazional (o dată la câțiva ani)",
              score: 0,
            },
            {
              label: "În fiecare an 1-2 montări",
              score: 2,
            },
            {
              label: "În fiecare an 3+ montări",
              score: 3,
            },
          ],
        },
        {
          id: "method",
          q: "Cum inseminezi/montezi?",
          options: [
            {
              label: "Montare naturală",
              score: 1,
            },
            {
              label: "KI spermă proaspătă/răcită",
              score: 2,
            },
            {
              label: "TE sau spermă congelată",
              score: 3,
            },
          ],
        },
        {
          id: "team",
          q: "Lucrezi cu medic veterinar/inseminator?",
          options: [
            {
              label: "O persoană fixă",
              score: 1,
            },
            {
              label: "Mai multe clinici",
              score: 2,
            },
            {
              label: "Rețea internațională",
              score: 3,
            },
          ],
        },
        {
          id: "tracking",
          q: "Ce ții minte acum?",
          options: [
            {
              label: "Excel sau hârtie",
              score: 1,
            },
            {
              label: "Aplicație generică gestionare cai",
              score: 2,
            },
            {
              label: "Nimic structurat",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "O unealtă hobby sau Excel este suficientă — dar EquiSight rămâne util.",
          body: "Pentru 1 iapă cu montare naturală o dată la câțiva ani, un modul de reproducție extins este excesiv. EquiSight începe gratuit și activezi modulul de reproducție doar pentru anul în care reproduci — fără obligație de actualizare.",
          cta: "Începeți gratuit",
        },
        mid: {
          title: "Reproducția EquiSight este uneltă corectă.",
          body: "Ai mai multe iaape sau mai multe metode de reproducție — pe acestea nu sunt construite aplicațiile generale de cai. EquiSight combină reproducție + grijă generală, deci nu trebuie să comutezi între două aplicații.",
          cta: "Vedeți modulul reproducție",
        },
        high: {
          title: "EquiSight este construit pentru grajdul dvs.",
          body: "Mai multe iaape, TE sau spermă congelată, echipă internațională — majoritatea uneltelor nu vin aici. EquiSight se scalează până la nivel grajd fără să stivuiți licențe suplimentare.",
          cta: "Vorbiți cu noi despre un plan Grajd",
        },
      },
    },
    faqTitle: "Întrebări frecvente despre software-ul de reproducție",
    faq: [
      {
        q: "Care este cel mai bun software de reproducție pentru cai?",
        a: "Pentru 1 iapă fără metode de reproducție complicate, multe unelte sunt suficiente. De la 2-3 iaape, utilizare KI sau TE, sau colaborare cu medic veterinar și registru genealogic devine crucial un modul complet de reproducție. EquiSight combină reproducție cu gestionare generală a cailor într-o singură aplicație, deci nu trebuie să comutezi.",
      },
      {
        q: "Care funcții de reproducție am cu adevărat nevoie?",
        a: "Minim: log ciclu, date inseminare/montare, repere control gestație și dosar mânz. Opțional dar puternic: afișare genealogică, arhivă alegere soi, ADN/pașaport și pipeline vânzare.",
      },
      {
        q: "Poate EquiSight prezice ciclul estrual al unei iaape?",
        a: "Da. EquiSight folosește date anterioare de ciclu pentru a arăta ovulația prezisă, deci planifici inseminare sau montare la momentul corect — fără puzzle zilnic.",
      },
      {
        q: "Funcționează EquiSight și pentru transfer embrionar?",
        a: "Da. Iapa donator și iapa destinatară primesc dosare conectate, calendar TE și repere partajate cu clinica. Deci nu pierzi o cronologie în fluxul complex TE.",
      },
      {
        q: "Pot importa datele de reproducție existente?",
        a: "Poți introduce manual ciclu, montări și date mânz sau în lot prin CSV. Pentru grajdele active cu reproducție, te ajutăm cu migrare unică dacă ai date pe mai mulți sezoane.",
      },
      {
        q: "Cum partajez dosarul cu medicul meu veterinar sau isneminatorul?",
        a: "Per persoană primești acces cu un rol: medic veterinar, inseminator, producător soi sau funcționar registru genealogic. Toată lumea vede doar informațiile necesare rolului - nu este nevoie de acces complet.",
      },
    ],
  },
  manege: {
    seo: {
      title: "Software pentru manej: comparație completă & ghid de alegere 2026",
      description: "Compară software pentru manej pentru lecții, călăreți, cai și administrație. Descoperă care aplicație se potrivește manejului sau pensiunii tale ecvestre.",
      keywords: [
        "software manej",
        "aplicație management grajd",
        "software administrație manej",
        "planificare lecții manej",
        "software pensiune ecvestră",
        "administrație călăreți",
        "administrație cai manej",
      ],
    },
    hero: {
      eyebrow: "Ghid de alegere · software manej",
      breadcrumbLabel: "Software manej",
      title: "Software pentru manej: ghidul complet de alegere pentru manejuri și pensiuni ecvestre.",
      intro: "Planificarea lecțiilor, administrarea călăreților, gestionarea cailor, facturare și comunicare — un software bun pentru manej le reunește pe toate. Compară cele mai cunoscute opțiuni și descoperă care se potrivește grajdului sau manejului tău.",
      pills: [
        {
          icon: "Calendar",
          label: "Planificare lecții",
        },
        {
          icon: "Users",
          label: "Călăreți & clienți",
        },
        {
          icon: "Heart",
          label: "Îngrijire cai",
        },
        {
          icon: "CreditCard",
          label: "Facturare",
        },
      ],
      ctas: [
        {
          label: "Solicită o demonstrație",
          href: "#start",
          primary: true,
        },
        {
          label: "Vezi tabelul comparativ",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "De ce instrumentele disparate încetinesc un manej.",
      lead: "Majoritatea manejurilor funcționează cu un sistem fragmentat: planificarea lecțiilor pe o tablă albă, înregistrarea călăreților în Excel, facturarea într-un alt instrument, îngrijirea cailor prin WhatsApp și comunicarea cu proprietarii prin mesaje personale. Într-o săptămână aglomerată apar rezervări duble, facturi uitate sau cai care nu știu ce călăreț îi va monta.",
      items: [
        "Cine are acum lecție cu Jasmijn?",
        "Ce călăreț nu a plătit încă pentru luna martie?",
        "Ce cal nu poate fi folosit săptămâna aceasta?",
        "Care sunt contactele de urgență ale elevilor?",
        "A primit proprietarul lui Stardust factura potcovarului?",
        "Ce cal stă în ce box?",
      ],
    },
    what: {
      title: "Ce este software-ul pentru manej?",
      lead: "Software-ul pentru manej combină planificarea lecțiilor, administrarea călăreților, gestionarea cailor, facturarea și comunicarea într-un singur instrument. Fără acrobații în Excel sau haos pe WhatsApp, ci un singur loc unde manejul funcționează și unde proprietarii/călăreții pot urmări totul.",
      targetGroupsTitle: "Pentru ce tip de afacere este destinat software-ul pentru manej?",
      targetGroups: [
        {
          icon: "Building2",
          title: "Manej mic (1-15 cai)",
          body: "În principal planificarea lecțiilor și plăților — administrație fără bătăi de cap.",
        },
        {
          icon: "Users",
          title: "Manej mediu (15-40 cai)",
          body: "Mai mulți instructori, planificare lecții + program cai + administrație călăreți.",
        },
        {
          icon: "ClipboardList",
          title: "Grajd mare de călărie și pensiune (40+)",
          body: "Operațiune completă inclusiv facturare, planificare hrănire și potcovar.",
        },
        {
          icon: "Heart",
          title: "Pensiune ecvestră",
          body: "Portal proprietar, instrucțiuni individuale de îngrijire, agendă partajată.",
        },
        {
          icon: "Target",
          title: "Grajd de antrenament pentru sărituri",
          body: "Planificare concursuri, antrenament per cal, contact cu clienții.",
        },
        {
          icon: "FileText",
          title: "Antreprenori ecvestri",
          body: "Combinație de lecții + pensiune + clinică + comerț — totul dintr-un singur sistem.",
        },
      ],
    },
    criteria: {
      title: "Ce trebuie să îndeplinească un software bun pentru manej?",
      lead: "O aplicație frumoasă nu înseamnă nimic dacă angajații tăi nu vor să o folosească. Cinci criterii practice care fac diferența dintre succes și frustrare.",
      items: [
        {
          icon: "Calendar",
          title: "Planificarea lecțiilor pe mai multe niveluri",
          body: "Începători/avansați, dresaj/sărituri, cuplări cal-călăreț și agendele instructorilor — toate vizibile simultan.",
        },
        {
          icon: "Users",
          title: "Administrarea călăreților",
          body: "Profiluri, nivel, abonament, carnet de lecții și legături de familie pentru călăreții juniori.",
        },
        {
          icon: "Heart",
          title: "Programul cailor",
          body: "Ce cal este folosit cât de des, cu perioade de odihnă, recuperare și contraindicații.",
        },
        {
          icon: "CreditCard",
          title: "Facturare & abonamente",
          body: "Abonamente lunare, carnete de lecții, lecții individuale și debitare automată.",
        },
        {
          icon: "Share2",
          title: "Portal proprietar (pensiune ecvestră)",
          body: "Proprietarii își văd calul în propria aplicație — agendă, costuri, potcovar și notițe fără a fi nevoie să sune.",
        },
        {
          icon: "Bell",
          title: "Comunicare & remindere",
          body: "Remindere automate pentru lecții, notificări de plată, anunțuri potcovar — fără mesaje pe WhatsApp.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs alte software-uri pentru manej.",
      lead: "Multe instrumente pentru manej sunt puternice în planificarea lecțiilor sau facturare, dar rareori în îngrijirea cailor și comunicarea cu proprietarii în același timp. Le comparăm cinstit unele cu altele.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "Equino",
        "Manege App",
        "Spreadsheet",
      ],
      rows: [
        {
          label: "Pornire gratuită / perioadă de probă",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Planificare lecții",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Mai mulți instructori",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Administrare călăreți",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Program cai",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Îngrijire cai (vaccinări/potcovar)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Carnet de lecții / abonament",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Plăți online",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Facturare automată",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Portal proprietar (pensiune)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Integrare potcovar/veterinar",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Remindere WhatsApp/SMS",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Mobil (iOS/Android)",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Planificare concursuri",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Potrivit pentru pensiune ecvestră",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
      ],
      note: "Comparație bazată pe funcționalitățile disponibile public în ianuarie 2026. Stalmanager este puternic în administrație, EquiSight se diferențiază prin fluxul de pensiune ecvestră + îngrijire cai + portal proprietar.",
    },
    why: {
      title: "De ce EquiSight este diferit pentru manejuri și pensiuni ecvestre.",
      lead: "EquiSight merge mai departe decât un simplu planificator de lecții. Vedem un manej ca o operațiune completă: cai, oameni, comunicare și finanțe — toate interdependente.",
      points: [
        {
          icon: "Heart",
          title: "Calul în centru, nu agenda",
          body: "Fiecare cal are propriul dosar. Utilizarea la lecții, sănătate, potcovar și concursuri într-o singură linie de timp — nu 3 instrumente separate.",
        },
        {
          icon: "Share2",
          title: "Proprietarii urmăresc fără a suna",
          body: "Proprietarii din pensiunea ecvestră au propria vizualizare: costuri, planificare, fotografii și notițe — economisește 5-10 apeluri telefonice pe săptămână.",
        },
        {
          icon: "Bell",
          title: "Comunicare automată",
          body: "Reminder lecție, reminder vaccinare, factură — automat, prin aplicație/email/SMS. Nu mai există broadcast-uri pe WhatsApp.",
        },
      ],
    },
    nicheB: {
      eyebrow: "Pentru pensiunea ecvestră",
      title: "Ce primește o pensiune ecvestră de la EquiSight.",
      lead: "Pensiunile ecvestre au provocări unice pe care software-ul obișnuit pentru manej nu le rezolvă.",
      cards: [
        {
          t: "Portal proprietar",
          d: "Fiecare proprietar vede doar calul (caii) săi, agenda și costurile.",
        },
        {
          t: "Instrucțiuni de îngrijire per cal",
          d: "Hrănire, furaje grosiere, suplimente, program pături — vizibile pentru personal.",
        },
        {
          t: "Agendă partajată",
          d: "Potcovar, veterinar și vizitele proprietarilor într-o singură vizualizare.",
        },
        {
          t: "Costuri de consum per cal",
          d: "Paie, furaje, concentrate facturate individual per proprietar.",
        },
        {
          t: "Contacte de urgență cal",
          d: "Proprietar + veterinar + potcovar mereu accesibili pentru personal.",
        },
        {
          t: "Gestionarea pășunatului",
          d: "Ce cai merg la pășune, la odihnă sau în reabilitare?",
        },
      ],
    },
    beforeAfter: {
      title: "De la tablă albă + Excel la EquiSight.",
      lead: "Concret: așa se schimbă o săptămână de lucru la manej.",
      rows: [
        {
          before: "Tablă albă cu planificarea lecțiilor",
          after: "Planificare live per instructor",
        },
        {
          before: "Excel cu călăreți + notițe lecții",
          after: "CRM clienți cu istoricul lecțiilor",
        },
        {
          before: "WhatsApp către proprietari",
          after: "Portal proprietari pentru calul lor",
        },
        {
          before: "Debitare lunară manuală",
          after: "Facturare automată + iDEAL",
        },
        {
          before: "Îngrijire cai pe un panou cu hârtii",
          after: "Instrucțiuni de îngrijire per cal, partajate",
        },
        {
          before: "Programare verbală potcovar",
          after: "Planificare potcovar cu confirmări",
        },
      ],
    },
    helper: {
      title: "Ce software pentru manej ți se potrivește?",
      lead: "5 întrebări pentru a vedea dacă EquiSight este platforma potrivită pentru manejul sau pensiunea ta ecvestră.",
      questions: [
        {
          id: "size",
          q: "Câți cai ai în afacerea ta?",
          options: [
            {
              label: "Mai puțin de 10",
              score: 1,
            },
            {
              label: "10-30",
              score: 2,
            },
            {
              label: "Mai mult de 30",
              score: 3,
            },
          ],
        },
        {
          id: "type",
          q: "Care este activitatea ta principală?",
          options: [
            {
              label: "În principal predarea lecțiilor",
              score: 1,
            },
            {
              label: "Pensiune ecvestră (cai în pensiune)",
              score: 3,
            },
            {
              label: "Combinație de lecții + pensiune",
              score: 3,
            },
          ],
        },
        {
          id: "instructors",
          q: "Cu câți instructori lucrezi?",
          options: [
            {
              label: "Doar eu",
              score: 1,
            },
            {
              label: "2-3 instructori",
              score: 2,
            },
            {
              label: "4 sau mai mulți",
              score: 3,
            },
          ],
        },
        {
          id: "billing",
          q: "Cum gestionezi facturarea în prezent?",
          options: [
            {
              label: "Manual (Word/Excel)",
              score: 3,
            },
            {
              label: "Program de contabilitate separat",
              score: 2,
            },
            {
              label: "Integrat în instrumentul de lecții",
              score: 1,
            },
          ],
        },
        {
          id: "owners",
          q: "Cum comunici cu proprietarii?",
          options: [
            {
              label: "Personal / WhatsApp",
              score: 3,
            },
            {
              label: "Email + WhatsApp",
              score: 2,
            },
            {
              label: "Portal proprietari în aplicație",
              score: 0,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Un instrument simplu sau Excel poate fi suficient deocamdată — dar EquiSight crește odată cu tine.",
          body: "Pentru o mică școală de echitație cu un singur instructor și puțină activitate de pensiune, un pachet extins nu este neapărat necesar imediat. EquiSight pornește gratuit și crește odată cu manejul tău — fără dureri de migrare peste câțiva ani.",
          cta: "Pornește gratuit",
        },
        mid: {
          title: "EquiSight este o îmbunătățire logică pentru manejul tău.",
          body: "Mai mulți instructori, o combinație de lecții și pensiune, sau facturare care acum este separată — EquiSight le reunește într-un singur flux de lucru. Mai ales portalul proprietarilor reduce semnificativ comunicarea ad-hoc.",
          cta: "Solicită o demonstrație",
        },
        high: {
          title: "EquiSight este construit pentru dimensiunea ta.",
          body: "Pensiune ecvestră + lecții + mai mulți instructori este exact locul unde EquiSight se diferențiază de instrumentele clasice pentru manej. Portalul proprietarilor și integrarea îngrijirii cailor economisesc ore de administrație și comunicare în fiecare săptămână.",
          cta: "Planifică o demonstrație pentru grajdul tău",
        },
      },
    },
    faqTitle: "Întrebări frecvente despre software-ul pentru manej",
    faq: [
      {
        q: "Care este cel mai bun software pentru manej?",
        a: "Pentru planificarea pură a lecțiilor există mai multe opțiuni bune. Din momentul în care ai nevoie de o pensiune ecvestră, mai mulți instructori sau urmărirea îngrijirii cailor, EquiSight devine soluția completă — fără jonglerie cu instrumente, totul într-un singur loc.",
      },
      {
        q: "Pot importa clienții și lecțiile existente?",
        a: "Da. Datele clienților și programele de lecții pot fi importate prin CSV. Ajutăm manejurile active cu o migrare unică, astfel încât să nu fie nevoie să introduci manual 200 de călăreți.",
      },
      {
        q: "Funcționează și pentru o pensiune ecvestră fără lecții?",
        a: "Da. Modul pensiune ecvestră dezactivează lecțiile și se concentrează pe portalul proprietarilor, hrănire/îngrijire, planificarea potcovarului și facturarea costurilor per cal.",
      },
      {
        q: "Pot călăreții să se înscrie și să plătească singuri?",
        a: "Da. Călăreții pot vedea prin propriul cont ce lecții sunt disponibile, se pot înscrie, plăti taxa de lecție cu iDEAL și cumpăra carnete de lecții.",
      },
      {
        q: "Cum stau lucrurile cu confidențialitatea datelor cailor și proprietarilor?",
        a: "Fiecare persoană are un rol (proprietar, călăreț, instructor, angajat). Per rol, vezi doar ceea ce ai nevoie. Proprietarii văd doar calul lor, călăreții doar propriile lecții.",
      },
      {
        q: "Poate EquiSight să se conecteze la software-ul meu de contabilitate?",
        a: "Da, conexiunile cu Exact, Moneybird și e-Boekhouden sunt disponibile. Facturile sunt transmise automat în sistemul tău de contabilitate.",
      },
    ],
  },
  trainer: {
    seo: {
      title: "Aplicație antrenor cal: comparație & ghid de alegere pentru antrenori 2026",
      description: "Compară aplicații pentru antrenori de cal și călăreț: jurnal de antrenament, video, obiective, analiza protocolului și gestionarea clienților. Găsește instrumentul potrivit pentru antrenori.",
      keywords: [
        "aplicație antrenor cal",
        "aplicație instructor ecvestru",
        "aplicație antrenament cal",
        "aplicație coaching călăreț",
        "jurnal antrenament cal",
        "analiză protocol dresaj",
        "software antrenor ecvestru",
      ],
    },
    hero: {
      eyebrow: "Ghid de alegere · software antrenor",
      breadcrumbLabel: "Aplicație antrenor",
      title: "Aplicație antrenor cal: ghid complet de alegere pentru instructori și antrenori.",
      intro: "Un antrenor sau instructor jonglează cu combinații, lecții, videoclipuri, obiective și concursuri. Compară cele mai bune aplicații pentru antrenori ecveștri și alege platforma care va ține pasul cu coaching-ul tău și în 2026.",
      pills: [
        {
          icon: "Target",
          label: "Obiective & planificare",
        },
        {
          icon: "Video",
          label: "Analiză video",
        },
        {
          icon: "TrendingUp",
          label: "Progres",
        },
        {
          icon: "Users",
          label: "Clienți/combinații",
        },
      ],
      ctas: [
        {
          label: "Începe gratuit ca antrenor",
          href: "#start",
          primary: true,
        },
        {
          label: "Spre tabelul comparativ",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "De ce coaching-ul prin WhatsApp îi încurcă pe antrenori.",
      lead: "Majoritatea antrenorilor lucrează cu instrumente separate: WhatsApp pentru comunicare, un carnet de notițe pentru lecții, YouTube sau WeTransfer pentru videoclipuri și Excel pentru rezultatele concursurilor. Cu 5 călăreți funcționează. Cu 20 de călăreți se pierd informații, uiți obiectivele și pierzi controlul asupra progresului individual.",
      items: [
        "Care este obiectivul Anei pentru acest sezon?",
        "Ce videoclip i-am trimis lui Bogdan luna trecută?",
        "A văzut Larisa analiza protocolului de la ultimul concurs?",
        "Ce combinație se antrenează de câte ori pe săptămână?",
        "A citit proprietarul lui Stardust instrucțiunile mele de antrenament?",
        "Când am dat ultima oară feedback despre impulsul fluctuant?",
      ],
    },
    what: {
      title: "Ce este o aplicație de antrenor pentru cal și călăreț?",
      lead: "O aplicație de antrenor combină un CRM de coaching (combinații, lecții, obiective), un jurnal de antrenament per cal, feedback video, planificare concursuri și analiză protocol. Nu mai e nevoie de WhatsApp/YouTube/Excel separate, ci o singură platformă unde antrenorul și călărețul lucrează împreună.",
      targetGroupsTitle: "Pentru ce tip de antrenor este destinat?",
      targetGroups: [
        {
          icon: "Target",
          title: "Instructor dresaj",
          body: "Scanează protocoale, leagă comentariile juriului de obiectivele de antrenament, urmărește progresul.",
        },
        {
          icon: "Activity",
          title: "Antrenor sărituri",
          body: "Planificarea parcursului, feedback pe reprize, gestionarea înălțimii per cal.",
        },
        {
          icon: "Award",
          title: "Antrenor eventing",
          body: "Trei discipline, trei planificări — toate vizibile alături una de alta.",
        },
        {
          icon: "TrendingUp",
          title: "Antrenor de performanță (sport)",
          body: "Urmărire EPI, concursuri, obiective — pentru sportivi de top și echipele lor.",
        },
        {
          icon: "Users",
          title: "Instructor de manej",
          body: "Lecții de grup + coaching individual într-o singură aplicație.",
        },
        {
          icon: "Heart",
          title: "Antrenor recreațional",
          body: "Terapie hipică, începători, proprietari cu un singur cal.",
        },
      ],
    },
    criteria: {
      title: "Ce trebuie să îndeplinească o aplicație bună de antrenor?",
      lead: "Antrenamentul este o muncă umană, dar instrumentul potrivit te face cu 30-50% mai eficient și îi ajută pe călăreți să progreseze și între lecții.",
      items: [
        {
          icon: "Users",
          title: "Gestionarea combinațiilor",
          body: "Cal + călăreț ca o unitate, cu nivel, obiective, progres și istoric.",
        },
        {
          icon: "ClipboardList",
          title: "Notițe de lecție & obiective",
          body: "O notiță per lecție cu puncte de focus, legată de obiectivele pe termen lung.",
        },
        {
          icon: "Video",
          title: "Feedback video",
          body: "Încarcă video, marchează momente, adaugă feedback vocal sau scris.",
        },
        {
          icon: "Target",
          title: "Analiză concurs & protocol",
          body: "Scanează protocoale (KNHS/FEI), vezi scoruri per element, comentariile juriului și tendințe.",
        },
        {
          icon: "Calendar",
          title: "Planificare & carduri de lecții",
          body: "Agendă, plăți, abonamente și memento-uri automate.",
        },
        {
          icon: "Share2",
          title: "Comunicare către călăreț",
          body: "Călărețul vede propria pagină cu lecții, videoclipuri, obiective și feedback.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs alte aplicații de antrenor.",
      lead: "Unele instrumente pentru antrenori se concentrează pe înlocuirea WhatsApp, altele pe analiza protocoalelor. EquiSight le combină pe ambele cu un dosar real al calului — astfel încât călărețul progresează și între lecții.",
      competitors: [
        "EquiSight",
        "Coach Apps (algemeen)",
        "HorseTrainer Pro",
        "EquiPilot",
        "WhatsApp + Excel",
      ],
      rows: [
        {
          label: "Începe gratuit",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Gestionarea combinațiilor",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Notițe de lecție & feedback",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Obiective pe termen lung",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Încărcare video + feedback",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Scanare protocol KNHS/FEI",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "EPI (Indice de performanță)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Calendar concursuri",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Portal călăreț",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Card lecții / abonament",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Plăți online",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Dosar integrat al calului",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Potcovar/veterinar vizibil",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Pentru instructor ȘI călăreț",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Mai mulți cai per călăreț",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
      ],
      note: "Comparație bazată pe funcționalități disponibile public în ianuarie 2026. EquiSight este unic prin analiza protocoalelor + EPI și combină acestea cu gestionarea generală a calului.",
    },
    why: {
      title: "De ce EquiSight oferă o experiență diferită de antrenor.",
      lead: "Majoritatea instrumentelor pentru antrenori se opresc acolo unde se termină lecția. EquiSight continuă — în dosarul calului, în analiza concursurilor, în colaborarea cu veterinarul și proprietarul.",
      points: [
        {
          icon: "TrendingUp",
          title: "Scanare protocol → obiectiv de antrenament",
          body: "Scanează un protocol KNHS și vezi imediat ce elemente necesită atenție. Obiectivele apar automat.",
        },
        {
          icon: "Sparkles",
          title: "EquiCoach îți ascute privirea",
          body: "Datele din mai multe lecții, concursuri și protocoale relevă tipare pe care nu le poți reține în minte.",
        },
        {
          icon: "Share2",
          title: "Integrat cu calul",
          body: "Antrenorul vede istoricul vaccinărilor, al potcovarului și al leziunilor calului — nu planifica antrenamente în timpul recuperării.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Pentru dresaj și sărituri",
      title: "Ce conține un dosar de coaching în EquiSight.",
      lead: "Per combinație primești un flux de coaching care ține totul la un loc — nu mai pierzi lucruri în WhatsApp.",
      items: [
        "Notițe de lecție cu puncte de focus per sesiune",
        "Obiective pe termen lung + jaloane",
        "Încărcare video cu comentarii pe timecode",
        "Scanare protocol KNHS/FEI cu scoruri",
        "Comentariile juriului legate de antrenament",
        "Rezultate concursuri și tendința EPI",
        "Contact client și istoricul lecțiilor",
        "Card lecții / abonament / facturi",
        "Grafic de progres per disciplină",
        "Acces partajat cu proprietarul calului",
      ],
      ctaLabel: "Vezi modulul antrenor",
      ctaHref: "/trainer",
    },
    beforeAfter: {
      title: "De la WhatsApp + YouTube la EquiSight Trainer.",
      lead: "Concret: cum se schimbă fluxul tău de coaching.",
      rows: [
        {
          before: "WhatsApp cu link-uri video disparate",
          after: "Video cu feedback pe timecode în dosar",
        },
        {
          before: "Carnet de notițe per călăreț",
          after: "Jurnal de coaching cu obiective + istoric",
        },
        {
          before: "Excel cu scoruri de concurs",
          after: "Grafic EPI + analiză protocol",
        },
        {
          before: "Obiective verbale",
          after: "Jaloane cu indicator de progres",
        },
        {
          before: "Instrument separat de facturare",
          after: "Lecții + iDEAL + abonament în aplicație",
        },
        {
          before: "E-mail proprietarului despre progres",
          after: "Proprietarul urmărește în propria vedere",
        },
      ],
    },
    helper: {
      title: "Ce aplicație de antrenor ți se potrivește?",
      lead: "5 întrebări pentru a vedea dacă un instrument specializat de coaching adaugă valoare practicii tale.",
      questions: [
        {
          id: "clients",
          q: "Câte combinații active antrenezi?",
          options: [
            {
              label: "Mai puțin de 5",
              score: 1,
            },
            {
              label: "5-15",
              score: 2,
            },
            {
              label: "Mai mult de 15",
              score: 3,
            },
          ],
        },
        {
          id: "discipline",
          q: "Care este disciplina ta principală?",
          options: [
            {
              label: "Dresaj",
              score: 3,
            },
            {
              label: "Sărituri",
              score: 2,
            },
            {
              label: "Recreațional / divers",
              score: 1,
            },
          ],
        },
        {
          id: "video",
          q: "Folosești video în coaching?",
          options: [
            {
              label: "Rar",
              score: 0,
            },
            {
              label: "Uneori (manual)",
              score: 2,
            },
            {
              label: "Des — în mod structurat",
              score: 3,
            },
          ],
        },
        {
          id: "comp",
          q: "Antrenezi călăreți de concurs?",
          options: [
            {
              label: "Nu, recreațional",
              score: 0,
            },
            {
              label: "Uneori la concursuri",
              score: 2,
            },
            {
              label: "Mult — cardurile de start sunt centrale",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Vrei să măsori coaching-ul tău?",
          options: [
            {
              label: "Nu, intuiția este suficientă",
              score: 0,
            },
            {
              label: "Da, dar nu am timp",
              score: 2,
            },
            {
              label: "Da — coaching bazat pe date",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Un instrument simplu sau chiar WhatsApp este suficient — pentru moment.",
          body: "Pentru mai puțin de 5 călăreți fără mult video sau concursuri, o aplicație de coaching este exces. EquiSight pornește gratuit, deci o poți încerca când practica ta crește.",
          cta: "Începe gratuit",
        },
        mid: {
          title: "EquiSight Trainer te face structural mai eficient.",
          body: "Cu 5-15 combinații pierzi ore pe lună cu WhatsApp și videoclipuri disparate. EquiSight le centralizează pe toate, scanează protocoalele automat și se asigură că călăreții pot revedea oricând feedback-ul primit.",
          cta: "Încearcă modulul Trainer",
        },
        high: {
          title: "EquiSight este construit pentru scala ta de coaching.",
          body: "Mulți călăreți, video, concursuri și coaching bazat pe date: exact acolo se diferențiază EquiSight. EPI + scanare protocol + dosar cal îți oferă un avantaj pe care concurenții nu îl au.",
          cta: "Programează o demonstrație pentru practica ta de coaching",
        },
      },
    },
    faqTitle: "Întrebări frecvente despre aplicațiile pentru antrenori",
    faq: [
      {
        q: "Care este cea mai bună aplicație de antrenor pentru cal și călăreț?",
        a: "Pentru comunicare pură, multe instrumente sunt suficiente (chiar și WhatsApp). Pentru obiective, analiză video, scanare protocoale, urmărire concursuri și gestionarea clienților într-un singur instrument, EquiSight este soluția cea mai completă — mai ales pentru că urmărește și calul în sine, nu doar combinația.",
      },
      {
        q: "Poate EquiSight să citească automat protocoalele de concurs?",
        a: "Da. Încarcă un protocol KNHS sau FEI și EquiSight extrage scorurile per element, comentariile juriului și le leagă de combinație. Tendințele sunt vizibile pe mai multe concursuri.",
      },
      {
        q: "Ce este EPI (Equestrian Performance Index)?",
        a: "EPI este un scor EquiSight care transformă mai multe rezultate de concurs într-un indice de performanță comparabil. Astfel, poți vedea progresul real prin diferite clase și jurii.",
      },
      {
        q: "Pot călăreții să rezerve și să plătească lecțiile singuri?",
        a: "Da. Călăreții se conectează, văd intervalele orare disponibile, cumpără carduri de lecții și plătesc prin iDEAL. Tu decizi ce vrei să oferi.",
      },
      {
        q: "Funcționează și pentru un instructor care lucrează în jurul unui manej?",
        a: "Da. Poți lucra ca antrenor independent cu proprii clienți fără să legi un cont de manej. Clienții îți plătesc direct.",
      },
      {
        q: "Pot migra videoclipurile și notițele existente?",
        a: "Videoclipurile pot fi încărcate per combinație sau printr-un instrument de încărcare în lot. Notițele se importă prin CSV. Îi ajutăm pe antrenorii activi cu o migrare unică.",
      },
    ],
  },
  gidsen: {
    seo: {
      title: "Ghiduri și instrumente de alegere pentru software de gestionare a cailor | EquiSight",
      description: "Toate ghidurile EquiSight într-un singur loc: gestionare cai, reproducție, software mănăți și antrenori, plus instrumente de alegere pentru 2026.",
      keywords: [
        "ghiduri software cai",
        "instrument alegere gestionare cai",
        "comparare software reproducție",
        "ghid software mănăți",
        "comparare aplicație antrenori",
      ],
    },
    hub: {
      eyebrow: "Hub · ghiduri",
      breadcrumbLabel: "Ghiduri",
      title: "Patru ghiduri complete pentru a alege software-ul potrivit pentru cai.",
      intro: "Pentru fiecare grup țintă, un instrument de alegere aprofundat: tabele de comparație, criterii, exemple și chestionar interactiv. Faceți clic pe ghidul care se potrivește situației dumneavoastră, sau exploraţi mai întâi articolele aprofundate din fiecare grup.",
      stats: {
        guides: "4 instrumente de alegere",
        articles: "15 articole aprofundate",
        fair: "Comparație corectă",
      },
      readMoreCta: "Citiți ghidul complet",
      relatedHeading: "Articole aprofundate",
      articlesCountSingular: "{{count}} articol aprofundat",
      articlesCountPlural: "{{count}} articole aprofundate",
      articlesCountAria: "Numărul de articole din grup",
      lastUpdatedPrefix: "Actualizat",
      lastUpdatedAria: "Data ultimei actualizări a acestui grup",
    },
    clusters: [
      {
        path: "/beste-paardenbeheer-app",
        icon: "Compass",
        title: "Instrument alegere aplicație gestionare cai",
        blurb: "Comparați cele mai cunoscute aplicații de gestionare a cailor și descoperiți care se potrivește proprietarilor, stailor sau reproducerilor. Include tabel de comparație corect și instrument de alegere cu 5 întrebări.",
        audience: "Pentru proprietari, crescători și toți oamenii care lucrează cu caii și caută ordine.",
      },
      {
        path: "/fokkerij-software-paard",
        icon: "Baby",
        title: "Comparare software reproducție",
        blurb: "De la ciclul iegoasei până la dezvoltarea mânzului: vedeți care software de reproducție funcționează cu adevărat pentru numărul de iegoase, metoda de reproducție și cerințele studbooku.",
        audience: "Pentru (hobby)producători, cai de rasă și crescători de armăsari.",
      },
      {
        path: "/manege-software",
        icon: "Building2",
        title: "Instrument alegere software mănăți",
        blurb: "Planificarea lecțiilor, administrare călăreți, portal proprietari și facturare — într-un singur instrument. Comparați opțiunile pentru mănăți și grajduri de pensiune în 2026.",
        audience: "Pentru mănăți, grajduri de pensiune și centre de echitație.",
      },
      {
        path: "/trainer-app-paard",
        icon: "Target",
        title: "Instrument alegere aplicație antrenori",
        blurb: "CRM coaching, feedback video, scanare protocol KNHS și obiective per combinație. Care aplicație antrenori se potrivește practicii dumneavoastră de coaching?",
        audience: "Pentru instructori, antrenori și coachi.",
      },
    ],
    closing: {
      eyebrow: "De ce aceste ghiduri",
      title: "Comparație corectă, nu doar prețuri.",
      body1: "Multe \"pagini de comparație\" sunt publicități mascate. Ghidurile noastre pun funcții, grup țintă și concurenți alături cum ar face-o o sursă de cunoștințe independentă. EquiSight apare firesc ca soluție completă, dar citești și corect unde alte aplicații sunt mai puternice.",
      body2: "Articolele aprofundate din fiecare ghid răspund la întrebările concrete care decurg din alegere: \"Când prima ecografie după inseminare\", \"Cum automatizez facturarea mănății\", \"Cum analizez un protocol de competiție\". Fără fluff de marketing, doar practică.",
      hubName: "Ghiduri EquiSight",
    },
  },
  ui: {
    sectionEyebrows: {
      pains: "De ce doare asta",
      basics: "Noțiuni de bază",
      criteria: "Ce îl face bun?",
      comparison: "Comparație corectă",
      why: "Diferența",
      beforeAfter: "De la fragmentare la claritate",
      helper: "5 întrebări",
    },
    table: {
      feature: "Funcție",
      today: "Astăzi",
      withEquisight: "Cu EquiSight",
    },
    helper: {
      questionLabel: "Întrebarea {{current}} din {{total}}",
      answerPrompt: "Răspunde la {{count}} întrebarea rămasă pentru a vedea o recomandare.",
      answerPromptPlural: "Răspunde la cele {{count}} întrebări rămase pentru a vedea o recomandare.",
      resultEyebrow: "Rezultatul tău",
    },
    targetGroupsFallback: "Pentru cine este destinat?",
    faqTitleFallback: "Întrebări frecvente",
  },
};

export default CORNERSTONES;
